import { CartSummaries } from '../types/cart';

export function filterVisibleCartSummaries(summaries: CartSummaries) {
  const oneOffTotalSummaries = summaries
    .filter(({ frequencyType }) => frequencyType === 'OneOffTotal')
    .map((summary) => ({ ...summary, billingFrequency: 'ONE_OFF' }));

  const recurringSummaries = summaries.filter(
    ({ frequencyType }) => frequencyType === 'NetRecurring',
  );

  return [...oneOffTotalSummaries, ...recurringSummaries];
}
